/* @flow */

import moment from 'moment';
import { NOMES_ETAPAS } from './constants';
import { MOMENT_FORMATO_BANCO } from '../utils/constants';
import { type EtapasId } from './types';

const criarEtapa = (etapasId: EtapasId, observacao?: ?string) => ({
    etapasId,
    observacao,
    entrada: moment().format(MOMENT_FORMATO_BANCO),
    nome: NOMES_ETAPAS[etapasId],
});

export default criarEtapa;
